





















































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import type * as Monaco from 'monaco-editor/esm/vs/editor/editor.api'
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

let monaco: typeof Monaco // dynamically imported

@Component({})
export default class FileEditor extends Vue {
  @Prop({
    type: String,
    required: true
  })
  value!: string

  @Prop({
    type: String,
    required: true
  })
  filename!: string

  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean

  @Prop({
    type: Boolean
  })
  sidebar!: boolean

  @Ref('monaco-editor') monacoEditor!: HTMLElement
  @Ref('editor-sidebar') editorSidebar!: HTMLElement

  // Our editor, once init'd.
  editor: Monaco.editor.IStandaloneCodeEditor | null = null

  // Base editor options.
  opts = {
    contextmenu: false,
    readOnly: this.readonly,
    automaticLayout: true,
    fontSize: 16,
    scrollbar: {
      useShadows: false
    },
    minimap: {
      enabled: (!this.isMobile)
    },
    rulers: (this.isMobile) ? [80, 120] : []
  }

  structures: any = []
  search = null
  open:any = []
  active:any = []

  @Watch('open')
  onOpenChange () {
    console.info('openValue', this.open)
  }

  // @Watch('active')
  // onActiveChange (value:any) {
  //   console.info('activeValue', this.active)
  // }

  get isMobile () {
    return this.$vuetify.breakpoint.mobile
  }

  async mounted () {
    // Init the editor.
    await this.initEditor()
    if (this.sidebar !== undefined) {
      this.initSidebar()
    }
  }

  async initEditor () {
    if (!monaco) {
      const { default: promise } = await import(
        /* webpackChunkName: "monaco-editor" */
        /* webpackPrefetch: -100 */
        './setupMonaco'
      )
      monaco = await promise
    }

    // Set the correct theme.
    if (this.$vuetify.theme.dark) {
      monaco.editor.setTheme('dark-converted')
    } else {
      monaco.editor.setTheme('light-converted')
    }

    // Create an editor instance.
    this.editor = monaco.editor.create(this.monacoEditor, {
      ...this.opts
    })

    // Define the model. The filename will map to the supported languages.
    const model = monaco.editor.createModel(
      this.value,
      undefined,
      monaco.Uri.file(this.filename)
    )
    this.editor.setModel(model)

    // Focus the editor.
    this.editor.focus()

    this.$emit('ready')
    this.editor.onDidChangeModelContent(event => {
      const value = this.editor?.getValue()
      this.structures = this.$store.getters['files/getStructure'](value)
      this.emitChange(value, event)
    })
  }

  initSidebar () {
    this.structures = this.$store.getters['files/getStructure'](this.value)
    this.editor?.onDidChangeCursorPosition(event => {
      const lineNumber = event.position.lineNumber
      // console.info('path', this.findPath(this.structures, lineNumber, null))
      this.active = [lineNumber]
      this.open.push(lineNumber)
      console.log('open', this.open)
    })
    const scrollbar = new PerfectScrollbar(this.editorSidebar, { suppressScrollX: true })
    window.addEventListener('resize', () => {
      scrollbar.update()
    })

    for (const structuresKey in this.structures) {
      this.open.push(this.structures[structuresKey].index)
    }
    console.info(this.open)
  }

  findPath (items:any[], index:number, path:number[]|null) {
    items.forEach((item:any) => {
      console.info('path1', items, index, path)
      if (path === null) {
        path = []
      }
      path.push(item.index)
      if (item.index === index) {
        return path
      }
      if (item.children) {
        return this.findPath(item.children, index, path)
      }
      return null
    })
  }

  // Ensure we dispose of our models and editor.
  destroyed () {
    if (monaco) monaco.editor.getModels().forEach(model => model.dispose())
    if (this.editor) this.editor.dispose()
  }

  emitChange (value: string | undefined, event: Monaco.editor.IModelContentChangedEvent) {
    this.$emit('change', value, event)
    this.$emit('input', value)
  }

  gotoLine (index: number) {
    this.editor?.revealLineNearTop(index)
    this.editor?.setPosition({
      column: 1,
      lineNumber: index
    })
    if (this.isMobile) {
      this.$emit('hideSidebar', false)
    }
  }

  filter (item:any, search:string) {
    return item.name?.startsWith(search) ? true : undefined
  }

  doActive (item:any, item2:any) {
    console.log('active-item', item, item2)
  }
}
